import { Component, OnInit } from '@angular/core';
import { ExamService } from 'src/app/services/Exam/exam.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';

@Component({
  selector: 'app-exam-score-card-type-class-map',
  templateUrl: './exam-score-card-type-class-map.component.html',
  styleUrls: ['./exam-score-card-type-class-map.component.css']
})
export class ExamScoreCardTypeClassMapComponent implements OnInit {

  ClassList: any;
  ExamScoreCardTypeList: any;
  Submitted: boolean = false;
  ExamScoreCardTypeClassMapList: any;


  constructor(private examservice: ExamService, private lookupService: LookupService, private globalHelper: GlobalHelper,
    private spinnerService: Ng4LoadingSpinnerService) { }

  ExamScoreCardTypeClassMapModel = {
    ExamScoreCardTypeClassMapID: 0,
    ExamScoreCardTypeID: 0,
    ClassID: 0,
    ReportType: 'ANNUAL',
    TermName: '',
    TermID: 0,
    ExamMapID: 0,
    IsActive: false
  };

  Clear() {
    this.ExamScoreCardTypeClassMapModel.ExamScoreCardTypeClassMapID = 0;
    this.ExamScoreCardTypeClassMapModel.ExamScoreCardTypeID = 0;
    this.ExamScoreCardTypeClassMapModel.ClassID = 0;
    this.ExamScoreCardTypeClassMapModel.TermID = 0;
    this.ExamScoreCardTypeClassMapModel.ExamMapID = 0;
    this.ExamScoreCardTypeClassMapModel.ReportType = 'ANNUAL';
    this.Submitted = false;

  }

  ExamMasterList = [];
  GetExamMaster() {
    this.spinnerService.show();
    this.ExamMasterList = [];
    this.ExamScoreCardTypeClassMapModel.ExamMapID = 0;
    this.ExamScoreCardTypeClassMapModel.TermID = this.ExamScoreCardTypeClassMapModel.TermID == null ? 0 : this.ExamScoreCardTypeClassMapModel.TermID;
    var item = {
      ItemId: this.ExamScoreCardTypeClassMapModel.ClassID,
      ItemId2: this.ExamScoreCardTypeClassMapModel.TermID,
    }
    this.lookupService.GetLookupsList('ExamEntry', JSON.stringify(item)).subscribe((data) => {
      this.ExamMasterList = data.LookupItems;
      this.spinnerService.hide();

    });
  };
  Edit(obj) {
    this.ExamScoreCardTypeClassMapModel.ExamScoreCardTypeClassMapID = obj.ExamScoreCardTypeClassMapID;
    this.ExamScoreCardTypeClassMapModel.ClassID = obj.ClassID;
    this.ExamScoreCardTypeClassMapModel.ReportType = obj.ReportType;
    if (obj.ReportType == 'TERMWISE') {
      this.GetTerm();
      this.ExamScoreCardTypeClassMapModel.TermID = obj.TermID;
    }
    this.ExamScoreCardTypeClassMapModel.TermName = obj.TermName;

    this.ExamScoreCardTypeClassMapModel.ExamScoreCardTypeID = obj.ExamScoreCardTypeID;

  }

  GetStatus = function (IsActive) {
    return IsActive ? 'Yes' : 'No';
  };


  GetExamScoreCardTypeClassMap() {

    this.spinnerService.show();
    this.examservice.GetExamScoreCardTypeClassMap().subscribe((data: any) => {
      this.ExamScoreCardTypeClassMapList = data.ExamScoreCardTypeClassMapList;
      this.globalHelper.CheckActionStatus(data);
      this.spinnerService.hide();

    });
  };

  ValidateDropdown() {
    return this.ExamScoreCardTypeClassMapModel.ClassID == 0 || (this.ExamScoreCardTypeClassMapModel.ReportType == 'TERMWISE' && this.ExamScoreCardTypeClassMapModel.TermID == 0);

  };


  SaveExamScoreCardTypeClassMap(valid) {

    this.Submitted = true;
    if (valid && !this.ValidateDropdown()) {
      this.spinnerService.show();
      this.examservice.SaveExamScoreCardTypeClassMap(JSON.stringify(this.ExamScoreCardTypeClassMapModel)).subscribe((data: any) => {
        if (data.webResponse.Status) {
          this.GetExamScoreCardTypeClassMap();
        }
        if (data.webResponse.Status) {

          this.GetExamScoreCardTypeClassMap();
        }
        this.globalHelper.CheckActionStatus(data);
        this.spinnerService.hide();
      });
    }

  };

  ngOnInit() {

    this.GetExamScoreCardType();
    this.GetClass();
    this.GetExamScoreCardTypeClassMap();
  }

  GetClass() {

    this.lookupService.GetLookupsList('Class', '').subscribe((data: any) => {
      this.ClassList = data.LookupItems;
    });

  }


  GetExamScoreCardType() {
    this.lookupService.GetLookupsList('ExamScoreCardTypeMST', '').subscribe((data: any) => {
      this.ExamScoreCardTypeList = data.LookupItems;
    });
  }

  TermList = [];
  GetTerm() {
    this.spinnerService.show();
    this.TermList = [];

    var ItemBo = {
      ItemId: this.ExamScoreCardTypeClassMapModel.ClassID
    }
    this.lookupService.GetLookupsList('ExamTerm', JSON.stringify(ItemBo)).subscribe((data) => {
      this.TermList = data.LookupItems;
      this.spinnerService.hide();
    });
  };
}
